module.exports = __webpack_public_path__ + "img/Menu-06.4e1bc9b4.png";